module.exports = __webpack_public_path__ + "img/join_bg.33274f52.png";